import { Component } from '@angular/core'

/* eslint-disable @angular-eslint/no-host-metadata-property */
/* eslint-disable @angular-eslint/component-selector */
@Component({
    selector: '[app-landing-page-section-container]',
    host: {
        '[class]': '"mx-auto flex flex-col p-10 lg:p-20 2xl:max-w-[1376px]"',
    },
    template: ` <ng-content></ng-content> `,
})
export class LandingPageSectionContainerComponent {}
